import { styled } from '@mui/material';
import { NodeState } from '../utils';
import {
  getStepNodeHoverStyles,
  getStepNodeStyles,
  getStepNodeSvgOverrideStyles,
  getStepNodeSvgStyles,
} from '../utils';

// Step circle/node
export const StepNode = styled('div')<{
  ownerState: NodeState;
  nodeIndex?: number;
  totalNodes?: number;
}>(({ theme, ownerState, nodeIndex = 0, totalNodes = 1 }) => ({
  ...getStepNodeStyles(theme, ownerState, nodeIndex, totalNodes),
  ...getStepNodeHoverStyles(),
  ...getStepNodeSvgStyles(theme, ownerState),
  ...getStepNodeSvgOverrideStyles(theme, ownerState),
}));
